import { useEffect } from 'react';
import { Modal, Row } from 'react-bootstrap';
import { FaXmark } from 'react-icons/fa6';
import './ModalPrivacidad.css'

import robotAbogado from '../assets/img/robot_abogado.avif';

const ModalPrivacidad = ({ showPrivacy, onClose }) => {

    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === 'Escape') onClose();
        };

        window.addEventListener('keydown', handleEsc);
        document.body.style.overflow = 'hidden';

        return () => {
            window.removeEventListener('keydown', handleEsc);
            document.body.style.overflow = 'unset';
        };
    }, [onClose]);


    const privacyContent = `<h2 style="color:  #FF89FF">1. Responsable del tratamiento</h2>
                    <p><strong>Juan Ángel Peñarrubia Aroca</strong></p>
                    <p>Email: penarrubia.92@gmail.com</p>

                    <h2 style="color:  #FF89FF">2. Datos recogidos</h2>
                    <ul>
                        <li>Nombre</li>
                        <li>Apellidos (opcional)</li>
                        <li>Correo electrónico</li>
                        <li>Teléfono (opcional)</li>
                    </ul>

                    <h2 style="color:  #FF89FF">3. Finalidad del tratamiento</h2>
                    <p>Responder a consultas laborales y profesionales de empresas interesadas en mi perfil profesional.</p>

                    <h2 style="color:  #FF89FF">4. Legitimación</h2>
                    <p>Consentimiento explícito del usuario al enviar el formulario de contacto, de conformidad con el artículo 6.1.a del Reglamento General de Protección de Datos (RGPD).</p>

                    <h2 style="color:  #FF89FF">5. Destinatarios</h2>
                    <p>Los datos se envían directamente a mi correo personal (penarrubia.92@gmail.com) y <strong>NO se comparten con terceros, salvo obligación legal</strong>.</p>

                    <h2 style="color:  #FF89FF">6. Plazo de conservación</h2>
                    <p>Los datos se conservarán durante el tiempo necesario para responder a la consulta y un máximo de 1 año para fines legales o hasta que el usuario solicite su supresión.</p>

                    <h2 style="color:  #FF89FF">7. Derechos de los interesados</h2>
                    <p>Puedes ejercer tus derechos de:</p>
                    <ul>
                        <li>Acceso</li>
                        <li>Rectificación</li>
                        <li>Supresión</li>
                        <li>Limitación</li>
                        <li>Portabilidad</li>
                        <li>Oposición</li>
                    </ul>
                    <p>Contactándome por email: penarrubia.92@gmail.com</p>

                    <h2 style="color:  #FF89FF">8. No almacenamiento en bases de datos</h2>
                    <p><strong>IMPORTANTE:</strong> Los datos recibidos únicamente se almacenan en mi bandeja de entrada de correo electrónico (proveedor de servicio: Google/Gmail) y no se guardan en ninguna base de datos ni sistema de almacenamiento externo.</p>

                    <h2 style="color:  #FF89FF">9. Seguridad</h2>
                    <p>Los datos se transmiten mediante protocolo seguro (HTTPS) y se gestionan conforme al RGPD.</p>

                    <p><em>Última actualización: Febrero 2026</em></p>`

    return (
        <div className="formacion-overlay" onClick={onClose}>
            <Modal
                show={showPrivacy}
                onHide={onClose}
                size="xl"
                centered
                className="cyber-modal"
                dialogClassName="modal-fullscreen-dialog"
                contentClassName="modal-fullscreen-content"
                onClick={(e) => e.stopPropagation()}
            >
                <Modal.Header
                    className="border-0 position-relative p-4 pb-3 d-flex align-items-center justify-content-center"
                    style={{
                        textAlign: 'center !important',
                        minHeight: '80px'
                    }}
                >
                    <h2
                        className="modal-title mb-0"
                        style={{
                            position: 'absolute',
                            margin: 0,
                            left: '50%',
                            transform: 'translateX(-50%)',
                        }}
                    >
                        Política de Privacidad
                    </h2>

                    <button
                        className="formacion-close position-absolute top-0 end-0 mt-2 me-2"
                        onClick={onClose}
                        style={{
                            border: 'none',
                            background: 'none',
                            zIndex: 20
                        }}
                    >
                        <FaXmark style={{ fontSize: '1.5rem', marginTop: '-4px' }} />
                    </button>
                </Modal.Header>
                <div className="border-light w-100 mt-2"
                    style={{
                        height: '2px',
                        background: 'rgba(0, 217, 255, 0.6)'
                    }}></div>

                <Modal.Body
                    className="p-4 modal-fullscreen-body p35"
                    style={{
                        maxHeight: '70vh',
                        overflowY: 'auto'
                    }}
                >
                    <Row className="g-4">
                        <div className="col-md-8">
                            <div dangerouslySetInnerHTML={{ __html: privacyContent }} />
                        </div>

                        <div className="col-md-4">
                            <div
                                style={{
                                    position: 'sticky',
                                    top: '25%'
                                }}
                            >
                                <img
                                    src={robotAbogado}
                                    alt="Política de Privacidad"
                                    className="img-fluid rounded-3"
                                    style={{
                                        width: '100%',
                                        maxHeight: '400px',
                                        objectFit: 'cover',
                                    }}
                                />
                            </div>
                        </div>
                    </Row>
                </Modal.Body>
            </Modal>
        </div>
    )
};

export default ModalPrivacidad;
